import React from 'react';

import PDPMobileImage from './pdp-mobile-image';
import VariantSwatch from './variant-swatch';
import PDPUpsell from './pdp-upsell';
import ProductDetailRow from '../../product/components/product-detail-row';
import KspList from '../../product/components/ksp-list';
import PDPOffersList from './pdp-offers-list';

import '../css/product-detail.less';
import '../css/parent-product-detail.less';

export const ParentProductDetail = ({ product, purchaseButton, handleTabChange, modifyProductWithVariant, 
    onAddOnChange, totalPrice, showCarepackModule, customConfig, carePacks, isMobileView }) => {

    const hasUpsell = !!product.upsell;
    const { attributes={}, fromReduxCache, pdpConfig={} } = product;
	const { pdpDetails={} } = pdpConfig;
	const hasBundle = !product.eol && !!product.bundle;
	const productDetailCLass = (!isMobileView ? "product-detail" : "pdp-mobile-content") + " parent-product-detail" +
                                (hasBundle || showCarepackModule ? " with-bundle" : "");

    return (
        <div className={productDetailCLass}>
            <h1 tabIndex={0} aria-label={product.name}>{product.name}</h1>
            <div className='desktop-block'>
                <ProductDetailRow 
                    product={product}
                    pdp={true}
                    displayAvgRating={true}
                    displaySkuID={false}
                    changeTab={() => handleTabChange('Reviews')} />
            </div>
            {product.offers.length > 0 && !pdpDetails.disableOffers &&
                <PDPOffersList
                    product={product}
                    changeTab={() => handleTabChange('Special Offers')}
                    message={'Special offers: '}/>
            }
            <div className='mobile-block'>
                <PDPMobileImage 
                    images={product.images}
                    sku={product.sku}
                />
                <div className='product-number'><span>Product #: </span>{product.sku}</div>
            </div>
            {!pdpDetails.disableKsps && !isMobileView ?
                <React.Fragment>
                <KspList ksps={product.ksps} limit={6}/>
                {!attributes.hideSpecsTab ?
                    <div className='spec-link'><span onClick={() => handleTabChange('Specs')}>See all Specs</span></div> : null }
                </React.Fragment>
                : null
            }
            { hasUpsell && <PDPUpsell product={product} withMetrics={true} /> }
            { !fromReduxCache ? <VariantSwatch
                product={product}
                purchaseButton={purchaseButton}
                modifyProductWithVariant={modifyProductWithVariant}
                onAddOnChange={onAddOnChange}
				totalPrice={totalPrice}
				showCarepackModule={showCarepackModule}
				carePacks={carePacks}
            /> : null}
            <div className="pdp-line"></div>
        </div>
    );
}
